export const REQUEST_ENDORSEMENT = "@@ENDORSEMENT/REQUEST_ENDORSEMENT";
export const SUCCESS_ENDORSEMENT = "@@ENDORSEMENT/SUCCESS_ENDORSEMENT";
export const FAILURE_ENDORSEMENT = "@@ENDORSEMENT/FAILURE_ENDORSEMENT";

export const REQUEST_ENDORSEMENTS = "@@ENDORSEMENTS/REQUEST_ENDORSEMENTS";
export const SUCCESS_ENDORSEMENTS = "@@ENDORSEMENTS/SUCCESS_ENDORSEMENTS";
export const FAILURE_ENDORSEMENTS = "@@ENDORSEMENTS/FAILURE_ENDORSEMENTS";

export const UPDATE_ENDORSEMENT_BODY = "@@ENDORSEMENT/UPDATE_ENDORSEMENT_BODY";
export const CLEAN_ENDORSEMENT_BODY = "@@ENDORSEMENT/CLEAN_ENDORSEMENT_BODY";
export const SET_LOADER_HELPER = "@@ENDORSEMENT/SET_LOADER_HELPER";

export default (state: any, action: any) => {
  switch (action.type) {
    case REQUEST_ENDORSEMENT:
      return {
        ...state,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_ENDORSEMENT:
      return {
        ...state,
        errors: {},
        success: {
          endorsement: action.payload,
        },
        //endorsement_body: {},
        loading: false,
      };

    case FAILURE_ENDORSEMENT:
      return {
        ...state,
        errors: {
          endorsement: action.payload,
        },
        success: {},
        loading: false,
      };

    case UPDATE_ENDORSEMENT_BODY:
      return {
        ...state,
        endorsement_body: {
          ...state.endorsement_body,
          ...action.payload,
        },
      };

    case CLEAN_ENDORSEMENT_BODY:
      return {
        ...state,
        endorsement_body: {},
        errors: {},
        success: {},
      };

    case SET_LOADER_HELPER:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
};
